/// <reference path="../types/index.d.ts" />

import '../client_forms/jimmiesbbq/style.css';
import FormStructure from './jimmiesbbq/form_structure';

export default FormStructure;